// extracted by mini-css-extract-plugin
export default {"list":"styles_list__sI3b-","item":"styles_item__jXv3q","department":"styles_department__Dw+fF","data":"styles_data__54GCQ"};